module.exports = __webpack_public_path__ + "img/entrance_statistics_empty.6661f3c9.svg";